import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import Button from "../../components/CustomButtons/Button";
// nodejs library to set properties for components

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material-ui icons
import MoreVert from "@material-ui/icons/MoreVert";


import { notification } from "antd";

import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import buttonStyles from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { ExportNoteQuestion } from "../../reduxToolkit/features/assessment/AssessmentSlice";
import ImportQuestionNotesModal from "../Components/ImportQuestionNotesModal";
import NewFile from "./DropFileInput/NewFile";

const useStyles = makeStyles(styles);
const useButtonStyles = makeStyles(buttonStyles);

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

export default function DropDownButtonExportImportQuestionNotes(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);

  // console.log(props.course,"props.course")

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");
  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const onFinish = async () => {
       let ExportData = {
      // group_id:
      // assessmentMethod-id:
      // course_id:
    }
    const resultAction = await dispatch(ExportNoteQuestion(ExportData));
    if (ExportNoteQuestion.fulfilled.match(resultAction)) {
      openNotificationWithIcon("success", `success Export`);
      handleClose();
    } else {
      if (resultAction.payload) {
        console.log(
          "resultAction.payload from component",
          resultAction.payload
        );
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
      } else {
        console.log("resultAction.error  from component", resultAction.error);
        setHandledError(resultAction.error);
        handleOpenErrorModal();
      }
    }
  };
  return (
    <div>
      <Button
        aria-controls="customized-menu"
        variant="contained"
        color="primary"
        onClick={handleClick}
        justIcon
        round
        aria-haspopup="true"
      >
        <MoreVert />
      </Button>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
       {/*  <ImportQuestionNotesModal
          courseID={props.courseID}
          handleClose={handleClose}
          course={props.course}
          program={props.program}
          semester_id={props.semester_id}
          group_name={props.group_name}
        /> */}
        <NewFile
          courseID={props.courseID}
          handleClose={handleClose}
          course={props.course}
          program={props.program}
          semester_id={props.semester_id}
          group_name={props.group_name}
          examID={props.examID}
          obj_Assessment={props.obj_Assessment}
        />

        <MenuItem
          onClick={() => {
            onFinish();
            props.export();

            // props.handleClose();
          }}
          style={{ color: "#AC79B0" }}
        >
          {t("Export Data")}
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
